import React, {
  useState,
  useRef,
  createRef,
  useEffect,
  useCallback
} from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Carousel } from 'antd';
import cssBI from '../common/BlockIntroduce.less';
import lessAS from '../product/ApplicationScenarios.less';

const TalScenes = ({ contents, type }) => {
  const [activeSolutionStep, setActiveSolutionStep] = useState(0);
  const refSolutionCarousel = useRef(null);
  let refs = useRef([
    createRef(),
    createRef(),
    createRef(),
    createRef(),
    createRef()
  ]);
  const refScenes = useRef(null);
  const pause = () => {
    refs.current.forEach((v) => {
      if (v.current) {
        v.current.pause();
      }
    });
  };
  const changeActiveSolutionStep = (num) => {
    pause();
    setActiveSolutionStep(num);
    refSolutionCarousel.current.goTo(num, true);
    if (
      refs.current[num] &&
      refs.current[num].current &&
      refs.current[num].current.nodeName === 'VIDEO'
    ) {
      refs.current[num].current.play();
    }
  };
  const handleVideoPlayOrPause = useCallback(() => {
    if (
      refs.current[activeSolutionStep] &&
      refs.current[activeSolutionStep].current &&
      refs.current[activeSolutionStep].current.nodeName === 'VIDEO'
    ) {
      const scenesModule =
        type === 'product'
          ? refScenes.current.parentNode.parentNode.parentNode
          : refScenes.current.offsetParent.offsetParent;
      if (window.scrollY > scenesModule.clientHeight + scenesModule.offsetTop) {
        pause();
      } else {
        refs.current[activeSolutionStep].current.play().catch(() => {
          throw new Error('当前视频未加载完成！');
        });
      }
    }
  }, [activeSolutionStep, type]);
  const handlePageVisibility = () => {
    if (document.hidden) {
      pause();
    } else if (
      refs.current[activeSolutionStep].current &&
      refs.current[activeSolutionStep].current.nodeName === 'VIDEO'
    ) {
      refs.current[activeSolutionStep].current.play().catch(() => {
        throw new Error('当前视频未加载完成！');
      });
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleVideoPlayOrPause);
    return function remove() {
      window.removeEventListener('scroll', handleVideoPlayOrPause);
    };
  }, [activeSolutionStep]);
  useEffect(() => {
    window.addEventListener('visibilitychange', handlePageVisibility);
    return function remove() {
      window.removeEventListener('visibilitychange', handlePageVisibility);
    };
  }, []);

  const carouselSettings = {
    swipeToSlide: false,
    swipe: false,
    dots: false,
    touchMove: false
  };

  let css;
  if (type === 'product') {
    css = lessAS;
  } else {
    css = cssBI;
  }
  return (
    <div className={css.scenesBox} ref={refScenes}>
      <div
        className={
          contents.length <= 3 ? css.scenesTypesBox : css.scenesTypesBoxLarge
        }
      >
        {contents.map((content) => {
          return (
            <div
              key={content.title}
              className={
                css.scenesType +
                ' ' +
                (activeSolutionStep === content.inx && css.active)
              }
              onClick={() => changeActiveSolutionStep(content.inx)}
            >
              {content.title}
              <span className={css.bottomLine} />
            </div>
          );
        })}
      </div>
      <Carousel ref={refSolutionCarousel} {...carouselSettings} effect="fade">
        {contents.map((content, index) => {
          return (
            <div key={content.desc} className={css.scenesContent}>
              <Row type="flex" justify="center">
                <Col span={type === 'product' ? 12 : 10}>
                  {content.image && (
                    <img
                      width="100%"
                      src={content.image}
                      alt={content.title}
                      style={
                        type === 'product'
                          ? {
                              width: '448px',
                              height: ' 270px',
                              margin: '0 auto'
                            }
                          : {
                              width: '448px',
                              height: ' 270px',
                              margin: '0 auto'
                            }
                      }
                    />
                  )}
                  <div className={css.videoBox}>
                    {content.video && (
                      <video
                        ref={refs.current[index]}
                        width="100%"
                        src={content.video}
                        controls
                        muted
                        autoPlay={content.inx === 0}
                        playsInline
                        disablePictureInPicture
                        controlsList="noremoteplayback nodownload"
                      />
                    )}
                  </div>
                </Col>
                <Col span={type === 'product' ? 12 : 14}>
                  <div className={`${css.scenesDesc} ${css.desc}`}>
                    {content.desc}
                  </div>
                </Col>
              </Row>
            </div>
          );
        })}
      </Carousel>
    </div>
  );
};
TalScenes.propTypes = {
  contents: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      desc: PropTypes.string,
      image: PropTypes.string
    })
  )
};
export default TalScenes;
